import React from "react";
import ReactDOM from "react-dom";
import { App } from "./App";
import { mergeStyles } from "@fluentui/react";
import reportWebVitals from "./reportWebVitals";
import { InteractionType, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider, MsalAuthenticationTemplate } from "@azure/msal-react";

import { BrowserRouter } from "react-router-dom";
import { initializeIcons } from "@fluentui/font-icons-mdl2";

import { APP_SETTINGS } from "./config/config";

import { Provider } from "react-redux";
import { store } from "./store/index";

// global styles
mergeStyles({
  ":global(body,html,#root)": {
    margin: 0,
    padding: 0,
    height: "100vh",
  },
});

initializeIcons();

// Apply initial theme from localStorage
const savedTheme = localStorage.getItem('theme') || 'default';
document.documentElement.classList.add(`theme-${savedTheme}`);

const msalInstance = new PublicClientApplication(APP_SETTINGS.MSAL_CONFIG);
// Set initial theme from localStorage
const storedTheme = localStorage.getItem('theme') || 'light';
document.documentElement.setAttribute('data-theme', storedTheme);

// eslint-disable-next-line no-restricted-globals
ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </MsalAuthenticationTemplate>
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
